import React from 'react';
import RootNavigator from './src/RootNavigator';
import Bootstrap from './src/components/Bootstrap';
import { Provider } from 'react-redux';
import store from './src/redux';
import { MenuProvider } from 'react-native-popup-menu';
import { StatusBar } from 'react-native';

Bootstrap();

export default function App(): JSX.Element {
	StatusBar.setBarStyle('dark-content');
	return (
		<Provider store={store}>
			<MenuProvider>
				<RootNavigator />
			</MenuProvider>
		</Provider>
	);
}
